const init = async () => {

    const inputFieldModifiers = [
        'name',
        'email',
        'organsiationnumber',
        'company',
        'invoiceaddress',
        'invoicezipcode',
        'invoicecity',
        'deliveryaddress',
        'deliveryzipcode',
        'deliverycity'
    ]

    const inputFields = inputFieldModifiers.map(modifier => document.querySelector(`.form__input--${modifier}`));

    if (!inputFields.some(field => field)) {
        return
    }

    inputFields.forEach((field) => {
        if (field) {
            field.classList.add('form__input--loading');
        }
    });

    const response = await fetch(`${location.origin}/api/v2/memberproperties/GetMemberProperties`)
    if (response.status !== 200) {
        inputFields.forEach((field) => {
            if (field) {
                field.classList.remove('form__input--loading');
                field.removeAttribute('disabled');
                field.setAttribute('value', '');
            }
        });
    }

    const memberProperties = await response.json()
    if (memberProperties.fullName === 'Uttransportsvc Merkurius') {
        return
    }

    inputFields.forEach((field, index) => {
        if (field) {
            const property = inputFieldModifiers[index]
            field.value = memberProperties[property] || ''
            field.classList.remove('form__input--loading');
            field.removeAttribute('disabled');
        }
    });
}

document.addEventListener('DOMContentLoaded', init)
